export default {
  productName: "Vikarn Typing Tutor",
  version: "0.0.9",
};
